import React, { useRef } from 'react';
import { titleMRClass } from 'src/components/common/common';

interface FileFormProps {
	title?: string;
	fileName: string;
	onChange: (name: string, fileName: string, fileData: string) => void;
	name: string;
	editable?: boolean;
	titleless?: boolean;
	accept?: string;
	/** 서버에 저장된 파일 ID (존재 시 파일명 다운로드 링크 표시) */
	resultFileId?: string;
	/** 그리드 셀 등에서 외부 file input을 사용할 때 전달 */
	onSelectClick?: () => void;
	onDownloadClick?: () => void;
	wrapperOption?: {
		wrapperStyle?: string;
		titleStyle?: string;
		inputStyle?: string;
	};
}

export const FileForm: React.FC<FileFormProps> = ({
	title,
	fileName,
	onChange,
	name,
	editable = true,
	titleless = false,
	accept,
	resultFileId,
	onSelectClick,
	onDownloadClick,
	wrapperOption = {
		wrapperStyle: 'w-[150px] min-w-[150px] mr-[10px] mb-[5px]',
		titleStyle: 'w-[150px] min-w-[150px]',
		inputStyle: 'w-[100px] min-w-[100px]',
	},
}) => {
	const fileInputRef = useRef<HTMLInputElement>(null);

	const stopGridEvent = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
	};

	const handleSelect = (e: React.MouseEvent) => {
		stopGridEvent(e);
		if (!editable) return;
		if (onSelectClick) {
			onSelectClick();
		} else {
			fileInputRef.current?.click();
		}
	};

	const handleDelete = (e: React.MouseEvent) => {
		stopGridEvent(e);
		if (editable) {
			onChange(name, '', '');
			if (fileInputRef.current) fileInputRef.current.value = '';
		}
	};

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (!file) return;

		const reader = new FileReader();
		reader.onloadend = () => {
			const result = reader.result as string;
			const base64 = result.replace(/^data:.*?;base64,/, '');
			onChange(name, file.name, base64);
		};
		reader.readAsDataURL(file);
	};

	return (
		<div
			className={`flex items-center h-[24px] ${wrapperOption.wrapperStyle}`}
			onMouseDown={stopGridEvent}
		>
			<p className={`${wrapperOption.titleStyle} form-title ${titleMRClass} ${titleless ? 'hidden' : ''}`}>
				{title}
			</p>
			<div className={`flex items-center gap-[4px] ${wrapperOption.inputStyle} h-full`}>
				{resultFileId && fileName ? (
					<button
						type="button"
						className="flex-1 truncate text-xs text-blue-600 underline text-left hover:text-blue-800 shrink min-w-0"
						title={fileName}
						onClick={(e) => {
							stopGridEvent(e);
							onDownloadClick?.();
						}}
					>
						{fileName}
					</button>
				) : (
					<span
						className="flex-1 truncate text-xs text-gray-700"
						title={fileName}
					>
						{fileName || '파일 없음'}
					</span>
				)}
				<button
					type="button"
					className={`text-white h-[20px] rounded-[4px] px-[6px] text-[11px] font-semibold shrink-0
						${editable ? 'bg-blue-dark cursor-pointer' : 'bg-gray-300 cursor-not-allowed'}`}
					onClick={handleSelect}
					disabled={!editable}
				>
					선택
				</button>
				<button
					type="button"
					className={`text-white h-[20px] rounded-[4px] px-[6px] text-[11px] font-semibold shrink-0
						${editable ? 'bg-red-light cursor-pointer' : 'bg-gray-300 cursor-not-allowed'}`}
					onClick={handleDelete}
					disabled={!editable}
				>
					삭제
				</button>
			</div>
			<input
				type="file"
				accept={accept}
				ref={fileInputRef}
				className="hidden"
				onChange={handleFileChange}
				onClick={stopGridEvent}
			/>
		</div>
	);
};
